import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';
import TextboxComponent from './TextboxComponent'
import TaskBarComponent from './TaskBarComponent'
import SubmitDecisionComponent from './SubmitDecisionComponent';
import AgendaComponent from './AgendaComponent'
import AddParticipantComponent from './addParticipantComponent';
import DecisionBoxComponent from './DecisionBoxComponent';



function MeetingNotesPage(props) {
  const [Participants, setParticipants] = useState([]);
  const [opiniondict, setopiniondict] = useState([]);
  const DecisionDict = [];
  const location = useLocation();


  const updateDecisionDict = (Decision) => {
    DecisionDict.push(Decision);
    return DecisionDict;
  }

  const updateopiniondict = (name, userOpinion) => {
    setopiniondict(() => {
      // Check if the name already exists in the opinionDict

      const existingUser = opiniondict.find((user) => user.name === name);



      if (existingUser) {
        // If the name exists, append the userOpinion to the existing opinions array
        existingUser.opinions.push(userOpinion);
        return opiniondict;
      } else {
        // If the name doesn't exist, create a new key-value pair in the opinionDict
        opiniondict.push({ name: name, opinions: [userOpinion] });

        return opiniondict;

      }
    });
  };

  return (
    <div className="MeetingNotesMain">
      <TaskBarComponent  />
      <AddParticipantComponent Participants={Participants} setParticipants={setParticipants} />
      <AgendaComponent agenda={location.state.agendaList} meetingName={location.state.meetingName} />
      
      <div className='userboxes'>
        {Participants.map((item) => (
          <TextboxComponent item={item} updateopiniondict = {updateopiniondict} />
        ))}
      </div>
      <DecisionBoxComponent updateDecisionDict = {updateDecisionDict}/>
      <SubmitDecisionComponent agenda={location.state.agendaList} meetingName={location.state.meetingName} opiniondict={opiniondict} DecisionDict={DecisionDict} />

    </div>
  );
};

export default MeetingNotesPage;
